module.exports = __webpack_public_path__ + "img/ring_g_0_null_null.6f896bee.png";